/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitees_NameInputs */

const en_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`invitees`)
};

const ar_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ja_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ru_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const th_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const tr_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_invitees_name = /** @type {(inputs: Invitees_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受邀者`)
};

/**
* | output |
* | --- |
* | "invitees" |
*
* @param {Invitees_NameInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invitees_name = /** @type {((inputs?: Invitees_NameInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitees_NameInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invitees_name(inputs)
	if (locale === "ar") return ar_invitees_name(inputs)
	if (locale === "de") return de_invitees_name(inputs)
	if (locale === "es") return es_invitees_name(inputs)
	if (locale === "fr") return fr_invitees_name(inputs)
	if (locale === "it") return it_invitees_name(inputs)
	if (locale === "ja") return ja_invitees_name(inputs)
	if (locale === "ko") return ko_invitees_name(inputs)
	if (locale === "pt_br") return pt_br_invitees_name(inputs)
	if (locale === "ru") return ru_invitees_name(inputs)
	if (locale === "th") return th_invitees_name(inputs)
	if (locale === "tr") return tr_invitees_name(inputs)
	if (locale === "zh_cn") return zh_cn_invitees_name(inputs)
	return zh_tw_invitees_name(inputs)
});